import React, { FC } from 'react';
import { ReactComponent as Spinner } from '../../../assets/Spinner/Spinner.svg';

interface Props {
  className: string;
}

export const SpinnerIcon: FC<Props> = ({ className }) => <Spinner className={className} />;
